import React from 'react'
import { Table, Tbody, Td, Thead, Tr } from 'react-super-responsive-table'

const BookingDetails = () => {
    return (
        <div className='light-shadow py-4 px-4 rounded-[2rem]'>
            <div className='flex items-center justify-between gap-4 px-4'>
                <div className='text-dark font-semibold'>
                    <p>Booking Details</p>
                </div>
                <div>
                    <button className="btn-primary py-1 text-sm" style={{
                        fontSize : '14px'
                    }}>
                        View All
                    </button>
                </div>
            </div>
            <div>
                <Table className='text-sm mt-4'>
                    <Thead>
                        <Tr className='font-semibold'>
                            <Td>Product id</Td>
                            <Td>Customer</Td>
                            <Td>Date</Td>
                            <Td>Status</Td>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {
                            [...Array(5).keys()].map(item => (
                                <Tr>
                                    <Td>RZ17308</Td>
                                    <Td>Pranjalpets</Td>
                                    <Td>13/01/2022</Td>
                                    <Td>
                                        <div className='bg-primary text-white px-2 rounded-md py-1 w-fit mx-auto'>
                                            choose one
                                        </div>
                                    </Td>
                                </Tr>
                            ))
                        }
                    </Tbody>
                </Table>
            </div>

        </div>
    )
}

export default BookingDetails